import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M17.888 10.897a2.876 2.876 0 0 0 2.472-2.841 2.875 2.875 0 0 0-2.406-2.836M19.729 14.25c1.35.202 2.294.675 2.294 1.65 0 .671-.445 1.107-1.163 1.381"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M11.887 14.664c-3.214 0-5.96.487-5.96 2.432s2.729 2.445 5.96 2.445c3.214 0 5.958-.482 5.958-2.428s-2.727-2.45-5.958-2.45M11.887 11.888a3.819 3.819 0 1 0-3.82-3.82 3.804 3.804 0 0 0 3.792 3.82z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M5.885 10.897a2.875 2.875 0 0 1-2.472-2.841A2.875 2.875 0 0 1 5.82 5.22M4.044 14.25c-1.351.202-2.294.675-2.294 1.65 0 .671.444 1.107 1.162 1.381"
    }, null, -1)
  ]))]))
}
export default { render: render }